import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { REGISTRATIONS_CLOSED } from '@/lib/registrationsClosed';

interface ClosedRouteProps {
  children: ReactNode;
}

/**
 * Wraps a registration route. While registrations are closed the route never
 * mounts, so a stale bookmark or an old email link lands on the landing page
 * and its thank-you message instead of a half-rendered form.
 *
 * `replace` keeps the closed URL out of history, so Back does not bounce.
 */
export const ClosedRoute: FC<ClosedRouteProps> = ({ children }) => {
  if (REGISTRATIONS_CLOSED) return <Navigate to="/" replace />;
  return <>{children}</>;
};
